import { ValidationStatus } from 'signup-ui-lego-core/types';
import { Data } from '../signup-data/DATA';
import { getSignupDataEntry } from '../store/signup-data/selectors';
export const shouldPrefillCompanyInfoForOnePage = state => {
  const isEmailValid = getSignupDataEntry(state, Data.Email).validation === ValidationStatus.VALID;
  const isCompanyDomainEmpty = getSignupDataEntry(state, Data.CompanyDomain).value === '';
  const isCompanyNameEmpty = getSignupDataEntry(state, Data.CompanyDomain).value === '';
  return isEmailValid && isCompanyDomainEmpty && isCompanyNameEmpty;
};